export const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || '2288166821956203';
const SCRIPT_ID = 'meta-pixel-script';

let isInitialized = false;
let isInitializing = false;
let lastPageViewKey = null;
const firedOnce = new Set();

const canUseDOM = () => typeof window !== 'undefined' && typeof document !== 'undefined';

const ensureFbq = () => {
  if (window.fbq) return window.fbq;

  const fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.push = fbq;

  window.fbq = fbq;
  window._fbq = fbq;
  return fbq;
};

const loadScript = () => {
  if (document.getElementById(SCRIPT_ID)) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.id = SCRIPT_ID;
  document.head.appendChild(script);
};

export const initPixel = (pixelId = META_PIXEL_ID) => {
  if (!canUseDOM() || isInitialized || isInitializing) return;
  if (!pixelId) return;

  isInitializing = true;
  const fbq = ensureFbq();
  loadScript();
  fbq('init', pixelId);
  isInitialized = true;
  isInitializing = false;
};

export const getPixelDiagnostics = () => {
  const hasDOM = canUseDOM();
  const fbq = hasDOM ? window.fbq : null;

  return {
    pixelId: META_PIXEL_ID,
    configured: /^\d{10,20}$/.test(META_PIXEL_ID),
    initialized: isInitialized,
    scriptPresent: hasDOM && Boolean(document.getElementById(SCRIPT_ID)),
    queueReady: typeof fbq === 'function',
    libraryReady: typeof fbq?.callMethod === 'function'
  };
};

const getFbq = () => {
  if (!canUseDOM()) return null;
  if (!window.fbq) {
    initPixel();
  }
  return window.fbq || null;
};

export const trackPageView = (location) => {
  const fbq = getFbq();
  if (!fbq) return;

  const key = location?.key || `${location?.pathname || ''}${location?.search || ''}${location?.hash || ''}`;
  if (lastPageViewKey === key) return;
  lastPageViewKey = key;

  fbq('track', 'PageView');
};

export const track = (eventName, payload = {}) => {
  const fbq = getFbq();
  if (!fbq) return;
  if (!eventName) return;

  if (payload && Object.keys(payload).length > 0) {
    fbq('track', eventName, payload);
  } else {
    fbq('track', eventName);
  }
};

export const trackOnce = (eventName, payload, dedupeKey) => {
  if (!dedupeKey) return track(eventName, payload);
  if (firedOnce.has(dedupeKey)) return;
  firedOnce.add(dedupeKey);
  track(eventName, payload);
};
